import 'jquery-ui-dist/jquery-ui.min.js';
import 'jquery-ui-dist/jquery-ui.min.css';
import { TypesenseSearchable, SearchableType } from './models/TypesenseSearchable';

export function bindSearch(elId) {
  $(elId).autocomplete({
    autoFocus: true,
    source: async function (request, response) {
      let typesenseResult = await TypesenseSearchable.get(request.term);
      if (typesenseResult && typesenseResult.hits.length) {
        // Transform hits data to match the format autocomplete expects
        let transformedData = typesenseResult.hits.map(hit => ({
          id: hit.document.id,
          label: hit.document.name,
          type: hit.document.type, // Assuming "type" property contains SearchableType
          country_slug: hit.document.country_slug,
          region_slug: hit.document.region_slug,
          slug: hit.document.slug, // Assuming "slug" property contains the item slug
          thumb_nail_url: hit.document.thumbnail_url,
          address: hit.document.short_address,
        }));
        response(transformedData);
      } else {
        response([]);
      }
    },
    focus(event, ui) {
      // jQuery UI's menufocus handler reads `item.value` on the focused menu
      // item. With an async `source` + `autoFocus`, the menu can focus an <li>
      // whose "ui-autocomplete-item" data is missing (ui.item is undefined),
      // which throws "Cannot read properties of undefined (reading 'value')".
      // Returning false here skips the widget's key-navigation `_value(...)`
      // call for that broken item. The liveRegion read is guarded separately
      // by the aria-label set in `_renderItem` below.
      if (!ui.item) {
        return false;
      }
    },
    select(event, ui) {
      event.preventDefault();
      let redirectUrl = `/trails/`;
      switch (ui.item.type) {
        case SearchableType.Country:
          redirectUrl += `${ui.item.slug}`;
          break;
        case SearchableType.Region:
          redirectUrl += `${ui.item.country_slug}/${ui.item.slug}`;
          break;
        case SearchableType.Trail:
          redirectUrl += `${ui.item.country_slug}/${ui.item.region_slug}/${ui.item.slug}`;
          break;
        default:
          break;
      }
      if (window.mapPage) {
        window.location = `${redirectUrl}/map`;
      } else {
        window.location = redirectUrl;
      }
    },
  }).autocomplete('instance')._renderItem = (ul, item) => {
    let template = '';
    template = `<div>
                  <img class='thumb_nail' src="${item.thumb_nail_url}"/>
                  <div class='detail'>
                    <b class="name">${item.label}</b>
                    <p> ${item.address ? item.address : ''}</p>
                  </div>
                </div>`;
    // Set aria-label so jQuery UI's menufocus liveRegion announcement reads
    // `ui.item.attr('aria-label')` and short-circuits before touching
    // `item.value` — otherwise a focused item with missing autocomplete data
    // throws "Cannot read properties of undefined (reading 'value')".
    return $('<li>')
      .attr('aria-label', item.label || item.address || '')
      .append(template)
      .appendTo(ul);
  };
}

if ($('#nav-search').length) {
  bindSearch('#nav-search');
}

if ($('#search').length) {
  bindSearch('#search');
}
